import { Controller } from "@hotwired/stimulus"

/**
 * Admin Confirm Dialog Controller - Confirmation dialog for destructive actions
 *
 * Features:
 * - Trigger from any button/link
 * - Escape key to close
 * - Body scroll lock when open
 * - Backdrop click to close
 * - Smooth transitions
 *
 * Usage:
 * <button data-action="click->admin-confirm-dialog#open" data-admin-confirm-dialog-url="/path">
 *   Delete
 * </button>
 */
export default class extends Controller {
  static targets = ["container", "backdrop", "dialog"]

  connect() {
    // Listen for escape key
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  // Open dialog from trigger button
  open(event) {
    event?.preventDefault()

    // Show container
    this.containerTarget.classList.remove("hidden")

    // Lock body scroll
    document.body.style.overflow = "hidden"

    // Add keydown listener
    document.addEventListener("keydown", this.boundHandleKeydown)

    // Animate in
    requestAnimationFrame(() => {
      this.backdropTarget.classList.add("opacity-100")
      this.dialogTarget.classList.add("scale-100", "opacity-100")
    })
  }

  // Close dialog
  close(event) {
    event?.preventDefault()

    // Animate out
    this.backdropTarget.classList.remove("opacity-100")
    this.dialogTarget.classList.remove("scale-100", "opacity-100")

    // Hide after animation
    setTimeout(() => {
      this.containerTarget.classList.add("hidden")

      // Unlock body scroll
      document.body.style.overflow = ""

      // Remove keydown listener
      document.removeEventListener("keydown", this.boundHandleKeydown)
    }, 150)
  }

  // Handle escape key
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
